import React from 'react'
import { useHistory, useLocation } from "react-router-dom";
import {
  List as ListIcon,
  Map,
  Activity
} from 'react-feather'
import { TabItem } from '../../../components';
import { useSelector } from 'react-redux';

const ListNav = () => {
  const location = useLocation()
  const translation = useSelector(state => state.translation.data)
  const language = useSelector(state => state.system.language)
  const [selected, setSelected] = React.useState(translation.VIEW.list[language.name])
  const history = useHistory()
  const isLoggedIn = useSelector(state => state.account.isLoggedIn)

  return (
    <div className="flex border-b mb-5 lg:mb-8">
      <TabItem
        selected={selected}
        onClick={setSelected}
        text={translation.VIEW.list[language.name]}
        icon={<ListIcon style={{width: '20px'}}/>}
        className="pt-5 lg:pt-0 px-5 lg:px-0 pb-3 lg:pb-4 lg:pr-1"
        accent
        uppercase
      />
      <TabItem
        selected={selected}
        onClick={
          () => {
            if (isLoggedIn) {
              history.push({
                pathname: '/organization-statistic',
                search: location.search
              })
            } else {
              history.push('/login')
            }
          }
        }
        text={translation.VIEW.statistic[language.name]}
        icon={<Activity style={{width: '20px'}}/>}
        className="pt-5 lg:pt-0 px-5 lg:px-0 pb-3 lg:pb-4 lg:pr-1 lg:ml-12"
        accent
        uppercase
      />
      <TabItem
        selected={selected}
        onClick={() => history.push({
          pathname: '/organization-map',
          search: location.search
        })}
        text={translation.VIEW.map[language.name]}
        icon={<Map style={{width: '20px'}}/>}
        className="pt-5 lg:pt-0 px-5 lg:px-0 pb-3 lg:pb-4 lg:pr-1 lg:ml-12"
        accent
        uppercase
      />
    </div>
  )
}

export { ListNav }
